import { Box, BoxProps, Typography } from '@mui/material';
import { TimeZoneEnum } from '@src/utils/timeZoneUtils';
import { DateTime } from 'luxon';
import React, { FunctionComponent } from 'react';
import { MoSelectionButton } from '../MoSelectionButton';

export type MoTimeSlotsProps = {
  timezone: TimeZoneEnum;
  timeSlots: { date: DateTime; times: DateTime[] }[];
  onChange?: (value: DateTime) => void;
  /** Omit for view-only usage: no slot renders as selected. */
  isChecked?: (currentDate: DateTime) => boolean;
  maxHeight?: BoxProps['maxHeight'];
};

export const MoTimeSlots: FunctionComponent<MoTimeSlotsProps> = ({
  timeSlots,
  timezone,
  onChange,
  isChecked,
  maxHeight = 'unset',
}) => {
  return (
    <>
      {timeSlots.map(({ date, times }) => {
        const zonedDate = date.setZone(timezone);
        return (
          <div key={`date-${zonedDate.toISODate()}`} data-cy="time-slot-day">
            <Typography sx={{ fontWeight: 'bold', mb: 1 }}>
              {zonedDate.toFormat('LLL d, cccc')}
            </Typography>

            <Box
              sx={{
                display: 'grid',
                gridTemplateColumns: '1fr 1fr 1fr',
                gap: 1,
                maxHeight,
                overflow: 'auto',
              }}
            >
              {times.length === 0 ? (
                <>No available times</>
              ) : (
                times.map((dateTime) => (
                  <MoSelectionButton
                    color="primary"
                    key={`datetime-${dateTime.toISO()}`}
                    id={`datetime-${dateTime.toISO()}`}
                    onChange={(event) => {
                      event.preventDefault();
                      onChange?.(dateTime);
                    }}
                    checked={isChecked?.(dateTime) ?? false}
                  >
                    {dateTime.setZone(timezone).toLocaleString(DateTime.TIME_SIMPLE)}
                  </MoSelectionButton>
                ))
              )}
            </Box>
          </div>
        );
      })}
    </>
  );
};
